module.exports = __webpack_public_path__ + "static/media/person.7f641611.svg";